module.exports = __webpack_public_path__ + "8da55ba20bab05e1a6f3380e98d8dadc.woff";